<figure>
	@if (isCurbstand()) {
		<div class="custom-logo-container">
			<img src="assets/img/curbstand-logo.webp" alt="Curbstand Logo" />
		</div>
	} @else {
		<corepark-logo />
	}
</figure>
<nav [class.curbstand]="isCurbstand()">
	@for (nav of navigation; track nav.url) {
		<a
			[routerLink]="nav.url"
			routerLinkActive="active"
			[routerLinkActiveOptions]="{ exact: true }"
			matRipple
			[matRippleColor]="'rgba(255, 255, 255, 0.16)'"
		>
			<option-icon [icon]="nav.icon" />
			<span>{{ nav.label }}</span>
		</a>
	}
</nav>
